import styled from 'styled-components';
export default styled.h2.withConfig({
  displayName: "ShareTitle",
  componentId: "sc-13x5xia-0"
})(["font-size:24px;margin-bottom:0.4em;@media screen and (min-width:800px){font-size:32px;}"]);